import '../styles/download.css';

const DownloadSection = () => {
  const cities = [
    { name: "Lusaka", count: "9,200+" },
    { name: "Ndola", count: "3,800+" },
    { name: "Kitwe", count: "2,900+" },
    { name: "Livingstone", count: "1,400+" },
    { name: "Kabwe", count: "950+" },
    { name: "+ More cities", count: "Nationwide" },
  ];

  return (
    <section className="download">
      <div className="download-bg"></div>
      <div className="container download-grid">
        <div className="download-left">
          <span className="section-tag" style={{ background: "rgba(255,255,255,0.1)", color: "white", border: "1px solid rgba(255,255,255,0.2)" }}>
            📲 Available Now
          </span>
          <h2 className="download-title">Download Free.<br />Start Today.</h2>
          <p className="download-desc">
            ZamWheelz is completely free to download. Post your first vehicle listing free and connect with thousands of buyers and sellers right across Zambia.
          </p>
          <div className="store-buttons">
            <button className="store-btn">
              <svg viewBox="0 0 24 24" fill="white" width="28" height="28">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div><small>Download on the</small><strong>App Store</strong></div>
            </button>
            <button className="store-btn">
                <svg viewBox="0 0 512 512" width="22" height="22">
                <path d="M7.9 22.2C5.1 25.5 3.5 30.1 3.5 35.8V476.3C3.5 482 5.1 486.5 7.9 489.9L10.2 492.2L262.2 240.2L262.2 235.8L10.2 19.8L7.9 22.2Z" fill="#3bccff" />
                <path d="M346.2 324.2L262.2 240.2L262.2 235.8L346.2 151.8L348.5 153.1L447.9 210.1C476.2 226.2 476.2 251.8 447.9 267.9L348.5 324.9L346.2 324.2Z" fill="#ffdb00" />
                <path d="M348.5 324.9L262.2 240.2L7.9 489.9C16.8 499.2 31.4 500.3 47.9 491.1L348.5 324.9" fill="#ff3b3b" />
                <path d="M348.5 153.1L47.9 22.9C31.4 13.7 16.8 14.8 7.9 24.1L262.2 235.8L348.5 153.1" fill="#48ff48" />
              </svg>
              <div><small>Get it on</small><strong>Google Play</strong></div>
            </button>
          </div>
          <p className="store-rating">★★★★★ 4.8/5 · Verified user reviews</p>
        </div>
        <div className="download-right">
          <h3 className="cities-title">Active Across Zambia</h3>
          {cities.map((c) => (
            <div className="city-row" key={c.name}>
              <span>{c.name}</span>
              <span className="city-count">{c.count} listings</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
